export default "__VITE_ASSET__CP4$jAM5__"